import React, { useMemo, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Avatar, Card, CardContent, DialogContent } from "@material-ui/core";
import { EnhancedTableToolbar } from "../Po/fragments/TableToolbar";
import AntDataGrid from "../../shared/components/AntDataGrid";
import { nanoid } from "@reduxjs/toolkit";
import { Col, Row, Tag } from "antd";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import Divider from "@material-ui/core/Divider";
import DirectionsIcon from "@material-ui/icons/Directions";
import { useForm } from "react-hook-form";
import { statusColors } from "../Po/constants";
import { DateTime } from "luxon";
import { epochToDate } from "../../shared/functions/toDateTime";
import ImageModal from '../Po/fragments/ImageModal';
import Button from '@material-ui/core/Button';
import { PoDetails } from '../Po/fragments/PoDetails';
import { selectPo } from "../../redux/slices/purchassingOrder";
import firestore from 'src/config/firebaseConfig';
import { useFirestoreConnect } from 'react-redux-firebase';
import { uniqBy, isArray, max } from "lodash";
import ItemCard from './ItemCard';

import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
        color: 'white'
    },
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function ActivePurchase({ items }) {
    const fontSize = 18;
    const classes = useStyles();
    const { register, handleSubmit } = useForm();
    const [filtered, setFiltered] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [open, setOpen] = useState(null);
    const [url, setUrl] = useState('');
    const [data, setData] = useState([]);

    const [selected, setSelected] = useState();

    const handleSelection = record => {
        console.log("kkKK" + JSON.stringify(record))
        console.log(record)
        setSelected(record)
        handleOpen();
    }

    const handleOpen = (_url) => {
        setUrl(_url)
        setOpen(true);
    };

    const handleCloseD = () => {
        setOpen(false);
    };

   
    const { lists } = useSelector(selectPo);

   



    const columns = [
        {
            title: '', dataIndex: 'image', key: 'image',
            render: (imageItem) => {
                return (
                    <React.Fragment>
                        {
                            imageItem && <Avatar onClick={() => handleOpen(imageItem)} alt={'...'} src={imageItem} />
                        }
                        {open && url === imageItem && <ImageModal
                            url={url}
                            open={open}
                            handleClose={handleCloseD}
                        />
                        }
                    </React.Fragment>
                )
            }
        },
        { title: 'Prosoft Id', dataIndex: 'proSoftId', key: 'proSoftId' },
        { title: 'Barcode', dataIndex: 'barcode', key: 'barcode' },
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Price', dataIndex: 'price', key: 'price' },
        { title: 'Qty.', dataIndex: 'quantity', key: 'quantity' },
        { title: 'Ship.', dataIndex: 'shippedQuantity', key: 'shippedQuantity' },
        { title: 'Disc.', dataIndex: 'discount', key: 'discount' },
        { title: 'Amount', dataIndex: 'amount', key: 'amount', render: value => (value || 0)?.toFixed(2) },
        { title: 'Recv.', dataIndex: 'isReceived', key: 'isReceived', render: value => String(value) },
        { title: 'Sell P.', dataIndex: 'sellPrice', key: 'sellPrice' },
        { title: 'Expires', dataIndex: 'expires', key: 'expires' },
    ];

    const list = useMemo(() => {


        if (!items) return [];

        let copy = []

        if (items && items.Purchases)
            for (const item of items.Purchases) {
                copy.push({
                    key: nanoid(),
                    id: item.ItemId,
                    image: item.ImagrUrl,
                    name: item.Name,
                    barcode: item.Barcode,
                    proSoftId: item.InternalId,
                    price: item.Price,
                    quantity: item.Quantity,
                    shippedQuantity: item.ShippedQuantity,
                    discount: item.Discount,
                    amount: item.Amount,
                    isReceived: item.Received,
                    sellPrice: item.SellPrice,
                    ClassItem: item.ClassItem,
                    Threshold: item.Threshold,
                    HasClilds: item.HasClilds,
                    expires: item.ExpirationDate && epochToDate(item.ExpirationDate),
                })

            }

        return copy;



    }, [items])
    // console.log(JSON.stringify(list));
    // console.log(list)
    // console.log(items)

    useFirestoreConnect(() => [
        { collection: 'purchase_orders', storeAs: 'purchase_orders', where: [['ActivityStatus', '==', 'InShipping']] }
    ])

    useFirestoreConnect(() => [
        { collection: 'purchase_orders', storeAs: 'purchase_orders_Pen', where: [['ActivityStatus', '==', 'Pending']] }
    ])


    let getpurchase_orders = useSelector((state) => state.firestore.ordered.purchase_orders);
    let getpurchase_orders_Pen = useSelector((state) => state.firestore.ordered.purchase_orders_Pen);

    // console.log(getpurchase_orders)
    // console.log(getpurchase_orders_Pen)


    let getActivePurchase = getpurchase_orders?.concat(getpurchase_orders_Pen);
    let mydataarry = [];


    getActivePurchase?.filter(element => element && element.Purchases)
        .forEach(element => {
            element.Purchases.forEach(elements => {
                mydataarry.push(elements)
            });
        });
    console.log('gggg'+mydataarry)


    // getActivePurchase.forEach(element => {

    //      console.log(element.Purchases);
    //     element.Purchases && element.Purchases?.forEach(elements => {

    //          console.log(elements);
    //         mydataarry.push(elements)
    //     });

    // });

    // console.log(mydataarry);

    // const groupBy = (arr, key, value) =>
    //     arr.reduce((acc, curr) => {
    //         acc[curr[key]] = (acc[curr[key]] || 0) + curr[value];
    //         console.log(JSON.stringify(acc[curr[key]]))
    //         return acc;
    //     }, {}); 



    const groupItems = (list, idKey) => {
        const groups = [];

        isArray(list) && list.forEach((e) => {
            const ex = { ...e };

            const exist = groups.find((i) => i[idKey] === ex[idKey]);

            if (exist) {
                exist.Quantity += ex.Quantity;
                exist.Price = max([exist?.Price, ex?.Price]);
            } else {
                groups.push(ex);
            }
        });

        return groups;
    };

    console.log(groupItems(mydataarry, 'ItemId'));


    mydataarry = groupItems(mydataarry, 'ItemId');

    // const listPo = useMemo(() => {
    //     if (!mydataarrys) return [];
        
        
        
    //     return mydataarrys.map(mydataarry => {
    //         var total = 0;
    //         var ind = 0;
    //         return ({
    //             id: mydataarry.id,
    //             ref: mydataarry.PoRef,
    //             vendor: mydataarry.VendorName,
    //             warehouse: mydataarry.WarehouseName,
    //             createdAt:epochToDate(mydataarry.CreateAt),
    //             status: mydataarry.ActivityStatus,
    //             deliveryType: mydataarry.DeliveryType,
    //             username: mydataarry.Username,
    //             Currency: mydataarry.Currency,
    //         })
    //     })
        
    // }, [mydataarrys])

    console.log(mydataarry);
    console.log(items)




    // const totalItem = useMemo(() => {

    //     let totals = 0;

    //     for (const { quantity } of list) {
    //         totals += quantity;
    //     }

    //     return (totals || 0)

    // }, [list]);

    // const totalVariety = useMemo(() => list.length, [list])

    // const ref = useMemo(() => {
    //     const toString = String(items.PoRef);
    //     const numberOfZero = 10 - toString.length;
    //     return `Po-${'0'.repeat(numberOfZero)}${toString}`
    // }, [items])
    // const {
    //     CreateAt,
    //     UpdateAt,
    //     Currency
    // } = items;

    // const createdAt = DateTime.fromJSDate(CreateAt.toDate()).toFormat('dd-MM-yyyy')
    // const updatedAt = DateTime.fromJSDate(UpdateAt.toDate()).toFormat('dd-MM-yyyy')


    // const handleSearch = ({ keyword }) => {
    //     let segments = keyword.split(' ');

    //     let filtered = []

    //     for (const segment of segments) {
    //         const found = list.filter(item => {
    //             return item?.name?.toLowerCase().includes(segment.toLowerCase())
    //                 || item?.proSoftId?.toLowerCase().includes(segment.toLowerCase())
    //                 || item?.barcode?.toLowerCase().includes(segment.toLowerCase());

    //         })

    //         found.forEach(item => {
    //             if (!filtered.find(one => one.id === item.id))
    //                 filtered.push(item)
    //         })

    //     }

    //     setFiltered(filtered)
    //     setIsSearching((segments.length > 0 && segments[0] !== ''))
    // }


    const [selectItem, setSelectItem] = useState({})
    const handleSelected = (row) => {
        setSelectItem(row)
    }


    return (
        <>

            {/* <div style={{ height: 600, width: '100%' }}>

                <AntDataGrid
                    columns={columns}
                    data={mydataarry}
                    size={'large'}
                    onRowClick={(e) => handleSelected(e.row)}

                />

            </div> */}

            <div>
                 {mydataarry.map(element => (
                    <ItemCard
                        key={element.ItemId}
                        Name={element.ItemName}
                        Barcode={element.ItemDescription}
                        ImageUrl={element.ItemImageUrl}
                    />
                ))}
            </div>
        </>

    );
}
